module.exports = __webpack_public_path__ + "97c040a0e755f00fb0a9715391ad8846.pdf";